import {getStringWidth} from '@visx/text';

import {VisxAxisConfig} from './getVisxAxisConfig';
import {DEFAULT_LABEL_STYLE} from './Theme';

export const GET_STRING_WIDTH_PADDING = 10;

export default function getTickLabelWidths({
  scale,
  suggestedNumTicks,
  tickLabelFormatter,
}: VisxAxisConfig): Array<number> {
  const ticks = 'ticks' in scale ? scale.ticks(suggestedNumTicks) : scale.domain();
  return (
    (ticks as Array<unknown>)
      .map((tick) => tickLabelFormatter(tick))
      // If a tick's label is empty Visx skips it, so it shouldn't be included
      .filter((label) => label.length > 0)
      .map(
        (label) =>
          // From testing, we've discovered getStringWidth to underestimate tick label widths by 5-10 pixels,
          // so add some padding to ensure no overlaps
          getStringWidth(label, DEFAULT_LABEL_STYLE)! + GET_STRING_WIDTH_PADDING
      )
  );
}
